<template>
    <div class="checkbox-validation-container" ref="modal">
        <div v-if="!cancel">
            <i18n-t keypath="login.termsOfUses.message" tap="p">
                <template #termsOfUses>
                    <a :href="url" target="_blank">{{
                        $t("global.modal.termsOfUses.title").toLowerCase()
                    }}</a>
                </template>
            </i18n-t>
        </div>
        <div v-else>
            <p>
                {{ $t("login.termsOfUses.secondMessage") }}
            </p>
        </div>

        <div class="accept-wrapper" @click="confirm = !confirm" v-if="!cancel">
            <BasicInput
                type="checkbox"
                class="checkbox"
                v-model="confirm"
                name="checkbox-terms-of-uses"
            />
            <p>{{ $t("login.termsOfUses.accept") }}</p>
        </div>

        <div class="buttons-wrapper">
            <BasicButton
                :loading="loading"
                :disabled="!cancel && (!confirm || loading)"
                @click="!cancel ? validTermsOfUses() : closeModal()"
                >{{
                    !cancel ? $t("button.accept") : $t("button.refuse")
                }}</BasicButton
            >
            <BasicButton color="blue" @click="cancelAction()">{{
                $t("button.cancel")
            }}</BasicButton>
        </div>
    </div>
</template>

<script>
import BasicInput from "@/components/basic/BasicInput.vue"
import BasicButton from "@/components/basic/BasicButton.vue"
import httpIntratone from "@/services/httpIntratone.js"

export default {
    components: {
        BasicInput,
        BasicButton,
    },

    props: {
        SID: {
            type: String,
            required: true,
        },
        connect: {
            type: Function,
            required: true,
        },
        url: {
            type: String,
            required: true,
        },
    },

    emits: ["update:title"],

    data() {
        return {
            confirm: false,
            cancel: false,
            loading: false,
        }
    },

    mounted() {
        this.deleteTitle()
    },

    methods: {
        validTermsOfUses() {
            this.loading = true
            let paramsAcceptCGU = new URLSearchParams()

            paramsAcceptCGU.append("cgu", this.confirm ? 1 : 0)
            paramsAcceptCGU.append("SID", this.SID)

            httpIntratone
                .post("data/gestionnaire/accept_cgu.php", paramsAcceptCGU)
                .then((response) => {
                    if (!response.data.error) {
                        this.connect(response)
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
                .finally(() => {
                    this.loading = false
                })
        },

        cancelAction() {
            this.cancel = !this.cancel
            this.$emit("update:title", this.cancel ? null : "termsOfUses.title")
        },

        deleteTitle() {
            if (this.$refs.modal.getAttribute("title")) {
                this.$refs.modal.removeAttribute("title")
            }
        },
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/global.scss";

p {
    margin: 0;
}

.checkbox-validation-container {
    text-align: center;
    display: flex;
    flex-direction: column;
    gap: 2em;
    align-items: start;
    font-size: $normal;

    .accept-wrapper {
        display: flex;
        align-items: start;
        gap: 0.5em;

        &:hover {
            cursor: pointer;
        }

        p {
            text-align: start;
        }

        .checkbox {
            width: 20px;
            aspect-ratio: 1;
        }
    }

    a {
        color: $orange-neutral;
        font-family: $font_avenir_black;
    }

    .buttons-wrapper {
        display: flex;
        justify-content: center;
        width: 100%;
        gap: 1em;
    }
}
</style>
